import React from 'react';
import { FadeIn } from './Shared';
import { XCircle } from 'lucide-react';
export const PainSection = () => {
  const pains = ['Tu hijo explota en el supermercado y no sabés qué hacer sin que te mire todo el mundo', 'Cedés el límite por vergüenza y después lo ruminás toda la noche', 'Perdés el control, le gritás y la culpa te aplasta antes de que se duerma', 'Cada berrinche es diferente y nunca sabés si estás haciendo lo correcto', 'Probaste de todo y a los 10 minutos volvés a lo mismo de siempre', 'El domingo a la noche ya sabés que la semana viene igual que la anterior'];
  return <section className="py-6 md:py-10 px-4 bg-navy-900 mt-[0px] mb-[0px]" data-id="element-224">
      <div className="max-w-3xl mx-auto" data-id="element-225">
        <FadeIn data-id="element-226">
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-white mb-6 text-center" data-id="element-227">
            ¿Cuántos berrinches más <br className="hidden md:block" data-id="element-228" />
            <span className="text-gold-400 italic" data-id="element-229">
              vas a manejar sin un sistema?
            </span>
          </h2>

          <div className="prose prose-invert mx-auto mb-8 text-gray-100 text-center" data-id="element-230">
            <p data-id="element-231">
              Sos un buen padre. Una buena madre. Amás a tu hijo con todo. Pero
              nadie te dijo que ibas a terminar el día sintiéndote peor que él.
            </p>
            <p data-id="element-232">
              Gritaste más de lo que querías. Cediste para que se callara. Y
              después vino la culpa.
            </p>
            <p className="font-medium text-white mt-2" data-id="element-233">
              No es falta de amor. Es falta de un sistema.
            </p>
          </div>

          <div className="bg-navy-800/50 border border-navy-700 rounded-2xl p-6 md:p-8 mb-8 shadow-xl" data-id="element-234">
            <ul className="space-y-4" data-id="element-235">
              {pains.map((pain, index) => <li key={index} className="flex items-start" data-id="element-236">
                  <XCircle className="w-6 h-6 text-red-400/80 mr-4 flex-shrink-0 mt-0.5" data-id="element-237" />
                  <span className="text-lg text-white" data-id="element-238">{pain}</span>
                </li>)}
            </ul>
          </div>

          <div className="text-center" data-id="element-239">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-gold-400" data-id="element-240">
              ¿Y si este fuera el último berrinche que manejás sin herramientas?
            </h3>
          </div>
        </FadeIn>
      </div>
    </section>;
};